// app/game/page.tsx
import React from 'react';
import { useUser } from '@clerk/nextjs'; // Import useUser from Clerk
import { redirect } from 'next/navigation'; // Import redirect from next/navigation

const GamePage = () => {
    const { isSignedIn } = useUser(); // Check if the user is signed in

    // Check authentication status and redirect if not signed in
    React.useEffect(() => {
        if (!isSignedIn) {
            redirect('/sign-in'); // Redirect to sign-in page if not signed in
        }
    }, [isSignedIn]);

    return (
        <div>
            {isSignedIn ? (
                <>
                    <h1>Sail the Boat Game!</h1>
                    <div id="gameContainer">
                        <canvas id="landCanvas" width="500" height="500"></canvas>
                        <div id="boat" className="boat" style={{ top: '0', left: '0' }}></div>
                        {/* Other game elements go here... */}
                    </div>
                </>
            ) : null} {/* Prevents rendering until user is authenticated */}
        </div>
    );
};

export default GamePage;